import '@/plugins/axios'
import Layout from '@/layout/layout.vue'


// 初始化菜单
export const initMenu = (store, router) => {

    if (store.state.user.menus.length > 0) {
        return;
    }
    //从服务器获取菜单信息
    window.axios.get('/login/menu').then((response) => {
        if (response) {
            let menus = response.data;
            menus.sort((a, b) => {
                return a.sort - b.sort;
            });
            let routes = getAsyncRoutes(menus);
            router.options.routes = routes; //生成菜单使用
            router.addRoutes(routes);    //添加到路由表中
            store.commit("user/SET_MENUS", routes);
        }
    }).catch(err => {
        console.log(err);
    })

}

// Layout 组件是项目中的主页面，切换路由时，仅切换Layout中的组件
function getAsyncRoutes(menus) {
    const res = []
    // 定义路由中需要的自定名
    const keys = ['path', 'name', 'children', 'iconcls', 'redirect', 'meta', 'hidden']
    // 遍历路由数组去重组可用的路由
    menus.forEach(item => {
        const newItem = {};
        if (item.component) {
            // 判断 item.component 是否等于 'Layout',若是则直接替换成引入的 Layout 组件
            if (item.component === 'Layout' || item.component == '') {
                newItem.component = Layout
            } else {
                //item.component 不等于 'Layout',则说明它是组件路径地址，因此直接替换成路由引入的方法
                // newItem.component = resolve => require([`@/views/${item.component}`],resolve)
                newItem.component = () => import(`@/views/${item.component}`)
            }
        }
        for (const key in item) {
            if (keys.includes(key)) {
                newItem[key] = item[key]
            }
        }
        // 若遍历的当前路由存在子路由，需要对子路由进行递归遍历
        if (newItem.children && newItem.children.length) {
            newItem.children = getAsyncRoutes(item.children)
        }
        res.push(newItem)
    })
    // 返回处理好且可用的路由数组
    return res
}
